import { useCallback, useMemo } from 'react';
import { toast } from 'react-toastify';
import { useAppDispatch } from 'src/app/hooks';
import PopUpContentWrapper from 'src/components/PopUpContentWrapper';
import Button from 'src/components/design-system/Button';
import PopUp from 'src/components/design-system/PopUp';
import { Reopen } from 'src/features/ViewReceiptsSlice';
import useBoolean from 'src/hooks/useBoolean';
import useReceiptDetails from 'src/hooks/useReceiptDetails';

const ReopenReceipt = () => {
  const {
    receiptData,
    recId,
    isCurrentDocLinked,
    isPoOpen,
    hasCompletedLinkedInvoice,
    getMessages,
    isReceiptActionButtonsDisabled,
    refreshPage,
  } = useReceiptDetails();
  const dispatch = useAppDispatch();
  const {
    value: isReopenReceipt,
    setTrue: enableIsReopenReceipt,
    setFalse: disableIsReopenReceipt,
  } = useBoolean();
  const { reOpenReceipt } = receiptData;

  const messages = useMemo(
    () => [...(isCurrentDocLinked && isPoOpen ? ['Receipt Linked to an Invoice'] : [])],
    [isCurrentDocLinked, isPoOpen]
  );

  const isDisabled = isReceiptActionButtonsDisabled(!!messages.length);

  const handleReopenReceipt = useCallback(async () => {
    enableIsReopenReceipt();
    await dispatch(Reopen([Number(recId)]))
      .then((res) => {
        toast.success('Receipt Re-opened successfully!');
      })
      .catch(console.error)
      .finally(() => {
        refreshPage();
        disableIsReopenReceipt();
      });
  }, [disableIsReopenReceipt, dispatch, enableIsReopenReceipt, recId, refreshPage]);

  return (
    <>
      {!hasCompletedLinkedInvoice && (
        <PopUp
          content={<PopUpContentWrapper type="Error" contents={getMessages(messages)} />}
          show={isDisabled}
        >
          <Button
            onClick={handleReopenReceipt}
            color="dark"
            buttonState={reOpenReceipt}
            disabled={isDisabled}
            loading={isReopenReceipt}
          >
            Re-Open
          </Button>
        </PopUp>
      )}
    </>
  );
};

export default ReopenReceipt;
